export default {
  views: {
    privacy: {
      lastUpdated: '最後更新時間 2026年09月10日',
      companyName: 'Linktivity 株式會社',
      title: '隱私權政策',
      personalInfoProtectionPolicy: '個人資訊保護方針',
      personalInfoProtectionDescription:
        '本公司於本公司所經營的預約網站 LINKTIVITY 等平台向客戶取得個人資訊。本公司認為，為使客戶能夠安心且便利地完成預約，保護客戶的個人資訊是極為重要之事，因此本公司遵守以下所載事項處理個人資訊。',
      customerDataManager: '客戶個人資料的管理者',
      companyAddress:
        '郵遞區號 100-0011 東京都千代田區內幸町 2-1-6 日比谷 Park Front 19F',
      acquisition: '取得階段',
      acquisitionDescription:
        '於法令要求之情形，本公司將於取得客戶同意後，取得為達成本公司利用目的所必需之最低限度個人資訊。',
      usage: '利用階段',
      usageDescription:
        '本公司僅為達成本公司所訂利用目的，使用自客戶取得之個人資訊。',
      storage: '保管·保存階段',
      storageDescription:
        '本公司為避免自客戶取得之個人資訊外洩，於個人資訊之保管·保存等作業中注重系統安全。',
      destruction: '銷毀·刪除階段',
      destructionDescription:
        '對於已無利用必要之個人資料（指日本《個人資訊保護法》所定之個人資料，以下相同），本公司將於無必要之時不遲延地予以銷毀。',
      customerInquiry: '對客戶諮詢等之因應',
      customerInquiryDescription:
        '對於客戶提出之持有個人資料（指日本《個人資訊保護法》所定之持有個人資料，以下相同）利用目的告知請求、揭露請求、更正·增補·刪除請求、停止利用·消除請求，以及停止提供予第三方之請求，本公司將依法令予以因應。',
      safetyMeasures: '安全管理措施等',
      safetyMeasuresDescription:
        '本公司除對所有與 LINKTIVITY 服務相關之員工實施教育訓練，使其了解個人資訊之重要性外，亦為個人資訊之安全管理採取必要且適當之措施。',
      tableOfContents: '目錄',
      policy1: {
        title: '關於本公司取得之個人資訊與利用目的',
        description:
          '本公司基於以下所列利用目的，取得並使用客戶之地址、姓名、出生年月日、聯絡方式、電子郵件地址或護照號碼等個人資訊。此外，本公司不會於未取得客戶同意之情況下取得需特別注意之個人資訊。又，於取得客戶個人資訊時，如個人資訊之利用目的尚未公布，本公司將就該次所取得個人資訊之利用目的向客戶告知或予以公布。此外，本公司不會於未取得監護人同意之情況下向 13 歲以下兒童取得個人資訊。客戶提供 13 歲以下兒童之個人資訊時，本公司將視為已取得監護人同意予以處理；惟如明確未取得同意，本公司將不會將該個人資訊用於聯絡監護人及其附隨目的以外之其他目的。',
        serviceUsage: {
          title: '為使用 LINKTIVITY 服務（會員註冊等）',
          description:
            '為使用 LINKTIVITY 服務，本公司將於公司內部共享客戶之個人資訊。',
          legalBasis: '為提供客戶所要求之服務或功能所必需。'
        },
        ticketPurchase: {
          title: '為辦理購票申請',
          infoItems:
            '於客戶向商品提供者申請購票等情形，本公司將取得客戶之姓名、支付資訊、護照號碼，以及健康狀況、病史等與客戶健康狀態相關之資訊等。',
          purpose:
            '本公司為確認客戶向商品提供者購票之資格，以及結算票款等費用而取得並使用客戶之個人資訊。此外，為上述目的，本公司將向商品提供者、交通機構、款項結算業者等（包含海外業者等）提供客戶之個人資訊。',
          legalBasis: '為提供客戶所要求之服務或功能所必需。'
        },
        newsletter: {
          title: '為寄送電子報（電子郵件雜誌等）等向客戶提供之各項通知',
          legalBasis: '基於客戶之同意進行蒐集。'
        },
        advertising: {
          title: '為透過社群媒體及廣告投放平台進行廣告宣傳',
          legalBasis: '基於客戶之同意進行蒐集。'
        },
        survey: {
          title: '為請求客戶填寫問卷調查',
          legalBasis:
            '為改善本公司之預約網站、商品及服務等，基於客戶之同意進行蒐集。'
        },
        analysis: {
          title: '為分析及管理客戶資訊',
          legalBasis:
            '透過改善本公司之預約網站、商品及服務等，為追求·保護客戶之正當利益所必需。'
        },
        fraudDetection: {
          title: '為偵測及防止信用卡等之不當使用',
          description1:
            '本公司為偵測及防止票券預約服務與會員註冊服務中之不當購買、非法轉售、冒用身分、不當支付、拒付（Chargeback）及其他不當行為，以及提升服務安全性之目的，可能取得並使用以下資訊。提供對象包含 Forter Inc. 及本公司另行公布之防詐服務提供業者。',
          description2:
            '本公司提供之資訊可能包含姓名、出生年月日、電子郵件地址、電話號碼、地址、預約資訊、購買紀錄、支付相關資訊、IP 位址、Cookie 資訊、瀏覽器資訊、終端裝置資訊、存取紀錄，以及其他為防止不當使用所必需之資訊。',
          description3:
            '提供對象將分析該等資訊，提供與交易相關之風險評估、不當使用判定、身分驗證支援及其他防詐服務。',
          description4:
            '本公司將該業者提供之分析結果及判定結果用於預約受理、會員註冊、身分驗證、支付處理、防止不當使用及服務營運，並可能據此判斷是否核准交易、暫緩交易或需要追加確認。',
          legalBasis:
            '透過防止不當使用及信用卡等之不當支付，為追求本公司與客戶之正當利益所必需。'
        }
      },
      policy2: {
        title: '關於將個人資料提供予第三方',
        description:
          '除以下任一情形外，本公司不會將自客戶取得之個人資料提供予第三方。',
        case1:
          '就將個人資料提供予第三方（包含商品提供者、海外旅行業者、社群媒體業者、廣告投放服務公司等業者），已透過同意本隱私權政策之方式或其他方式事先取得客戶同意之情形',
        case2:
          '於為達成上述利用目的所必需之範圍內，將個人資料之處理委託予外部之情形',
        case3: '依法令被要求提供之情形',
        case4: '為保護人之生命、身體或財產而有必要，且難以取得客戶同意之情形',
        case5:
          '為提升公共衛生或促進兒童健全成長而有特別必要，且難以取得客戶同意之情形',
        case6:
          '國家或地方公共團體等於執行法令所定事務時有協助之必要，且因取得客戶同意而可能妨礙該事務執行之情形'
      },
      policy3: {
        title: '關於向位於外國之第三方提供個人資料',
        description1:
          '作為前條所規定之情形，本公司為偵測及防止本服務中之不當交易，可能將客戶之個人資料提供予位於外國之第三方。',
        description2:
          '本公司依照《個人資訊保護法》及其他相關法令，於向客戶提供有關向位於外國之第三方提供個人資料所必需之資訊後，取得客戶同意，或基於其他合法方式進行該項提供。',
        description3:
          '對於提供對象所在國之個人資訊保護制度相關資訊、該第三方所採取之個人資訊保護措施，以及其他法令上要求提供之資訊，本公司將透過於本公司網站刊載或本公司認為適當之其他方式予以公布或提供。',
        description4:
          '為偵測及防止本服務中之不當交易而自客戶取得，並提供予位於外國之第三方之資料項目等詳情如下。',
        item1Label: '（1）提供之個人資料項目',
        item1Content:
          '線上交易資訊（使用者 ID、會員編號、姓名、電子郵件地址、電話號碼、地址等）、裝置資訊（作業系統種類、語言、IP 位址、瀏覽器種類、位置資訊、終端識別號碼等）',
        item2Label: '（2）提供之手段或方法',
        item2Content:
          '電子方式（線上交易資訊經雜湊處理後，以不可讀狀態傳送。）',
        item3Label: '（3）詐欺偵測服務業者及其所在外國之名稱等',
        companyNameLabel: '業者名稱：',
        companyName: 'Forter, Inc.',
        countryLabel: '所在國家：',
        country: 'United States',
        addressLabel: '地址：',
        address: '575 5th Avenue, New York, United States (10017)',
        representativeLabel: '代表人：',
        representative: 'Michael Reitblat',
        item4Label: '（4）關於該外國之個人資訊保護制度之資訊',
        item4Content: '請透過以下個人資訊保護委員會網站確認。',
        item5Label: '（5）詐欺偵測服務營運業者所採取之個人資訊保護措施',
        item5Content: '請透過以下 Forter 公司網頁（隱私權政策等）確認。',
        description5:
          '客戶於會員註冊或購票時同意本隱私權政策之情形，本公司可能視為客戶亦已一併同意本項所規定之向位於外國之第三方提供個人資料。'
      },
      policy4: {
        title: '關於個人資料處理之委託',
        description:
          '本公司依前項規定，於為達成本公司利用目的所必需之範圍內將客戶之個人資料處理委託予第三方時，將對受託方實施必要且適當之監督。此外，受託方進行再委託時，本公司將直接或間接監督受託方是否對再受託方實施必要且適當之監督。再受託方再為委託之情形亦同。'
      },
      policy5: {
        title: '關於 Cookie 資訊等之取得',
        cookie: {
          title: 'Cookie',
          description1:
            '本公司可能使用工作階段 Cookie 及其他 Cookie。Cookie 係儲存於使用者硬碟中、包含客戶（使用者）相關資訊之一種資料。本公司不會將 Cookie 作為識別特定個人之資訊加以使用。此外，工作階段 Cookie 於關閉瀏覽器後即會刪除。',
          description2:
            'Cookie 用於提升對客戶之服務、本公司網站之個人化設定及衡量廣告效果等目的。',
          description3:
            '此外，本公司透過將 Cookie 作為統計處理資料加以分析，探知客戶關注及感興趣之事項並加以運用，同時亦用於防止非法存取。',
          description4:
            '客戶可依自身意願停用 Cookie，惟停用後客戶將無法於 LINKTIVITY 進行預約。此外，本公司為防止不當使用及交易風險評估之目的，可能取得 Cookie、裝置識別碼及其他類似資訊，並提供予防詐服務提供業者。'
        },
        logFile: {
          title: '日誌檔案',
          description1:
            '本公司會自動蒐集特定資訊並儲存於日誌檔案。該特定資訊包含 IP（網際網路協定）位址、瀏覽器類型、ISP（網際網路服務供應商）、來源／離開頁面、作業系統、日期／時間戳記。本公司基於監控非法存取之目的使用該等資訊。此外，本公司亦進行客戶傾向分析、網站管理，以及客戶於網站上之行為追蹤。',
          description2:
            '惟本公司於使用該等資訊時，會使其無法識別特定個人，且不會將所取得之資訊用於上述以外之目的。本公司為防止不當使用及提升安全性，可能取得 IP 位址、瀏覽器資訊、終端識別資訊、存取紀錄及其他線上識別資訊，並提供予防詐服務提供業者。'
        },
        webBeacon: {
          title: '關於網路信標',
          description:
            '本公司將網路信標用於存取分析及聯盟行銷（Affiliate）計畫。本公司不會將網路信標用於上述以外之目的，亦不會用於識別特定個人。'
        },
        statisticalAnalysis: {
          title: '關於統計分析',
          description1:
            '為確認何種網站或服務較受歡迎，本公司使用第三方存取分析工具，記錄客戶於 LINKTIVITY 網站內所瀏覽之頁面及頁面瀏覽紀錄。',
          description2:
            '本公司使用該等資料，以便於 LINKTIVITY 內向對特定領域表現出興趣之客戶提供符合其興趣之內容與廣告。',
          description3:
            '此外，本公司亦可能蒐集不識別個人之統計資訊。再者，本公司亦可能於第三方存取分析工具上，使本公司所蒐集之 Cookie 資訊與其他公司所蒐集之 Cookie 資訊可供雙方查閱。'
        }
      },
      policy6: {
        title: '關於匿名加工資訊之處理',
        creation: {
          title: '匿名加工資訊之製作',
          description1:
            '本公司於製作匿名加工資訊時，將採取以下措施。所謂匿名加工資訊，係指採取法令所定措施對個人資訊進行加工，使其無法識別特定個人而取得之個人相關資訊，且已使該個人資訊無法回復原狀者。',
          description2:
            '①依法令所定標準適當地進行加工；②依法令所定標準，為防止已刪除之資訊及加工方法相關資訊外洩而採取安全管理措施；③公布所製作匿名加工資訊中所含資訊之項目；④不實施為識別製作時所使用個人資訊之本人之行為'
        },
        provision: {
          title: '匿名加工資訊之提供',
          description:
            '將匿名加工資訊提供予第三方時，本公司將公布擬提供之匿名加工資訊中所含個人相關資訊項目及提供方法，同時向作為接收方之第三方明示所提供之資訊為匿名加工資訊。'
        },
        disclosure: {
          title: '關於匿名加工資訊之公布',
          creationSubtitle: '關於匿名加工資訊之製作',
          creationDescription:
            '就本公司所持有之以下客戶個人資訊，本公司於採取適當措施使其無法識別特定個人且無法回復個人資訊後，將持續製作為匿名加工資訊。',
          itemsTitle: '匿名加工資訊中所含個人相關資訊之項目',
          itemsDescription:
            '與平台服務之提供相關而取得之資訊——購買日、參加日、憑證（Voucher）語言、銷售金額區間、參加人數、預約狀態（預約確定或取消等）、供應商所在地區及縣資訊、旅行社所在國家',
          thirdPartyTitle: '關於將匿名加工資訊提供予第三方',
          thirdPartyDescription:
            '就本公司所製作或持有之匿名加工資訊，本公司將於明示該資訊為匿名加工資訊後，持續提供予第三方。',
          provisionMethod:
            '透過電子通訊方式（電子郵件、上傳至伺服器、API 介接等）或 DVD 等實體媒介寄送以密碼保護之電子檔案'
        }
      },
      policy7: {
        title: '關於個人資料之安全管理措施',
        description1:
          '為防止個人資料外洩、盜用、濫用、非法存取、竄改及破壞等，本公司採取組織性、技術性、物理性之安全管理措施。對本公司儲存個人資料之伺服器的存取，僅限持有 ID／密碼之特定員工；其中部分個人資料之管理，僅授予資料管理等作業所需最低限度之員工存取權限。',
        description2:
          '此外，對於包含信用卡資訊之個人資料，本公司分散於多個資料中心並保管於安全環境之中。又，本公司於所有與預約交易相關之頁面均使用 Secure Sockets Layer（SSL）加密。透過使用支援 SSL 之瀏覽器，可維持於網際網路上傳輸之個人資料與信用卡資訊之機密性。',
        description3:
          '此外，本公司處理客戶個人資料之員工於離開終端裝置時，會使用以密碼保護之螢幕保護程式。',
        description4:
          '再者，本公司依部門每月一次、全公司每半年至少一次之頻率，實施關於個人資訊重要性等之教育訓練。此外，本公司亦保存教育訓練相關紀錄。'
      },
      policy8: {
        title: '關於客戶個人資料處理之相關權利',
        description:
          '依據 2016 年 4 月 27 日之歐盟《一般資料保護規則》（GDPR）2016/679，就個人資料之處理，客戶享有以下權利。',
        right1: '查閱權',
        right2: '更正權',
        right3: '刪除權（被遺忘權）與限制處理之權利',
        right4: '資料可攜權',
        right5: '提出異議之權利',
        right6:
          '不受包含使用者剖析（Profiling）在內之自動化處理所為決定拘束之權利。'
      },
      policy9: {
        title: '關於揭露·更正·停止利用等請求',
        description1:
          '對於客戶提出之持有個人資料利用目的告知請求、揭露請求、更正·增補·刪除請求、停止利用·消除請求或停止提供予第三方之請求（以下統稱「揭露等請求」），本公司將透過下述第 12 項所載之聯絡窗口予以因應。',
        description2:
          '此外，本公司將透過客戶之「我的頁面」，因應變更及確認會員資訊、停止接收電子報等需求。'
      },
      policy10: {
        title: '關於外部連結',
        description:
          'LINKTIVITY 網站首頁包含連往其他網站之連結。本隱私權政策僅適用於透過 LINKTIVITY 網站首頁所蒐集之資訊，對於其他網站之隱私權政策或內容，本公司不負責任。敬請客戶於各連結目標網站閱讀其隱私權政策，確認自身個人資訊之處理方式。'
      },
      policy11: {
        title: '關於隱私權政策之變更',
        description:
          '本公司將隱私權政策刊載於 LINKTIVITY 網站首頁，使客戶得以隨時了解本公司取得並使用客戶何種個人資訊、用於何種目的。此外，隱私權政策之變更亦刊載於 LINKTIVITY 網站首頁，向客戶予以公布。'
      },
      policy12: {
        title: '關於聯絡方式',
        description1:
          '關於本公司之隱私權政策、本公司於個人資訊保護方面之作為、客戶個人資訊之取得與利用等問題，或揭露等請求，請利用以下諮詢表單。負責人員將於 5 個工作日內回覆。',
        company: 'Linktivity 株式會社',
        address:
          '郵遞區號 100-0011 東京都千代田區內幸町 2-1-6 日比谷 Park Front 19F',
        dpoContact: '資料保護負責人聯絡方式: dpo@linktivity.co.jp'
      },
      contentLabels: {
        acquisitionOfPersonalInfo: '取得之個人資訊項目',
        specificPurpose: '具體之利用目的',
        legalBasis: '法律依據：',
        provisionMethod: '提供方式'
      }
    },
    product: {
      plans: {
        title: '選擇套餐'
      },
      cancelPolicy: {
        title: '取消政策'
      },
      recommendations: {
        title: '其他推荐'
      },
      panels: {
        selectDate: '選擇日期',
        selectPlan: '選擇套餐',
        selectPeople: '選擇人數',
        options: '附加商品',
        profile: '個人資料'
      },
      auth: {
        loginOrRegister: '登入 / 註冊'
      }
    },
    book: {
      title: '訂單確認',
      bookingNotice: '請在預訂前確認',
      paymentConfirmation: '請在支付前確認',
      tip: '為確認訂單，請在15分鐘內完成操作',
      sessionInfo: '預訂信息'
    },
    bookConfirm: {
      productInfo: '商品資訊',
      sessionConfirmed: '已確認',
      sessionUnconfirmed: '未確認',
      paymentInfo: '付款資訊',
      paymentConfirmation: {
        warningTitle: '請確認取消政策：',
        warningText: '該商品一旦購買將無法退款。',
        agreementText: '我已確認並同意'
      },
      prePaymentConfirmation: {
        title: '付款前確認事項',
        checkInput: '請確認輸入內容是否正確。',
        emailNotice:
          '注意：如果您設置了域名郵件過濾，請在預約前將「@linktivity.co.jp」添加到白名單。',
        agreementText: '我已確認並同意上述事項。'
      },
      paymentAmount: {
        total: '支付金額（含税）',
        details: '詳細',
        note: '日圓以外的幣種金額為依據當前匯率計算的預估金額，與實際扣款金額可能略有差異，僅供參考。'
      },
      confirmPaymentDialogTitle: '付款確認',
      participantInfo: {
        title: '參與者資訊',
        dialogTitle: '修改參與者資訊',
        change: '變更',
        password: '密碼',
        validation: {
          passwordRequired: '請輸入密碼'
        }
      },
      couponApplied: '優惠券已成功使用',
      couponFailed: '優惠券使用失敗',
      couponRemoved: '優惠券已成功移除',
      couponRemoveFailed: '優惠券移除失敗',
      actionButtons: {
        back: '返回',
        toPayment: '去付款'
      }
    },
    voucher: {
      pdf: '打印用PDF',
      html: '憑證'
    },
    bookingDetail: {
      title: '預訂詳情',
      detailInfo: '預訂詳情',
      startDate: '參加日期',
      validityPeriod: '有效期',
      voucherInfo: '憑證',
      digitalTicket: '電子票',
      invoice: '收據/發票',
      invoiceSend: '開立',
      invoiceSent: '發票已開立',
      redemption: '使用電子票',
      meetingPoint: '入場位置指南',
      beforeTrip: '使用前確認事項',
      bookingAction: '預訂操作',
      cancelBooking: '取消預訂',
      cancelConfirmPolicy: '請確認取消政策：',
      customerName: '預訂人',
      actualPayment: '付款金額',
      refundAmount: '退款金額',
      orderId: '預訂ID',
      orderCompletionTime: '預訂時間',
      digitalTicketValidPeriod: 'QR碼僅在使用當天有效',
      digitalTicketWaiting: '*訂單確認後，電子票將在此顯示',
      sending: '發送中...',
      sendToEmail: '發送至郵箱',
      cancelConfirm: '是否確認取消訂單？',
      cancelFee: '取消費用',
      cancelRemarkSelect: '請選擇取消原因',
      inclusion: '包含的物品',
      checklist: '注意事項',
      restrictions: '參加限制',
      requirements: '參加前及參加時須知事項',
      attireItems: '參加時所需服裝及攜帶物品',
      otherInfo: '備考・其他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: '圖片'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '其他',
      CANCEL_REASON_MODIFY_BOOKING: '變更預訂日期或人數',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '誤訂',
      CANCEL_REASON_DUPLICATE_BOOKING: '因重複預訂',
      CANCEL_REASON_HEALTH_CONDITION: '生病',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '航班取消、延誤或變更',
      CANCEL_REASON_SCHEDULE_CONFLICT: '行程有變',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '改訂為其他商品'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'SHIBUYA SKY',
      header: {
        alt: 'SHIBUYA SKY'
      },
      search: {
        placeholder: '搜尋商品'
      },
      ticketList: {
        title: '票券一覽'
      },
      enjoyPack: {
        title: '暢遊套餐'
      }
    },
    faq: {
      tips: `如您對本 FAQ 中的內容（如線上購票、取消、開立收據等）有任何疑問，請聯絡 LINKTIVITY 客戶服務中心。
如您對 SHIBUYA SKY 的設施、服務等有任何疑問，請透過 SHIBUYA SKY 官方網站的聯絡頁面洽詢。
https://www.shibuya-scramble-square.com/sky/contact/

LINKTIVITY 客戶服務中心
電子郵件：<a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
線上購票相關諮詢電話：<a href="tel:+81368217193">03-6821-7193</a>
※來電後將先由自動語音系統為您導引，之後會依您的諮詢內容轉接至客服人員。
※電話諮詢將產生通話費用。
客服人員服務時間：10:00～19:00`
    }
  }
};
